import { Injectable } from "@angular/core"
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from "@angular/router"
import { Observable, of } from "rxjs"
import { PreviewService } from "../../services/preview.service"

@Injectable()
export class CollectionPreviewGuard {
    constructor(public previewService: PreviewService) {}
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        this.previewService.previewOnCollection = true
        return of(true)
    }

    canDeactivate(
        component: any,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        this.previewService.previewOnCollection = false

        return of(true)
    }
}
